import dispatcher from "./../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import standardAttributeConstants from "../Constants/StandardAttributeConstants";

let addorUpdateStandardAttribute = null;
let queryList = null;
let standardAttributeList = null;
let deletestandardAttribute = null;
let attributeType = null;
let attributeOptions = null;
let saveUpdateWerkOptionsRes = null;
let standardAttrOptions = null;
let queryDataResult = null;

class StandardAttributeStores extends EventEmitter {
  getAddorUpdateStandardAttributeResult() {
    return addorUpdateStandardAttribute;
  }

  setAddorUpdateStandardAttributeResult(res) {
    addorUpdateStandardAttribute = res;
  }

  getQueryListResult() {
    return queryList;
  }

  setQueryListResult(res) {
    queryList = res;
  }
  getstandardAttributeList() {
    return standardAttributeList;
  }

  setstandardAttributeList(res) {
    standardAttributeList = res;
  }
  getDeletestandardAttribute() {
    return deletestandardAttribute;
  }

  setDeletestandardAttribute(res) {
    deletestandardAttribute = res;
  }

  getAttributeTypes() {
    return attributeType;
  }

  setAttributeTypes(res) {
    attributeType = res;
  }

  getAttributeOptions() {
    return attributeOptions;
  }

  setAttributeOptions(res) {
    attributeOptions = res;
  }

  getSaveUpdateWerkOptionsRes() {
    return saveUpdateWerkOptionsRes;
  }

  setSaveUpdateWerkOptionsRes(res) {
    saveUpdateWerkOptionsRes = res;
  }

  getStandardAttributeOptions() {
    return standardAttrOptions;
  }

  setStandardAttributeOptions(res) {
    standardAttrOptions = res;
  }

  getQueryDataResult() {
    return queryDataResult;
  }

  setQueryDataResult(res) {
    queryDataResult = res;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case standardAttributeConstants.ADDORUPDATE_STANDARD_ATTRIBUTE_SUCCESS:
        this.setAddorUpdateStandardAttributeResult(action.result);
        break;
      case standardAttributeConstants.ADDORUPDATE_STANDARD_ATTRIBUTE_FAILURE:
        this.setAddorUpdateStandardAttributeResult(action.result);
        break;
      case standardAttributeConstants.GET_QUERY_LIST_SUCCESS:
        this.setQueryListResult(action.result);
        break;
      case standardAttributeConstants.GET_QUERY_LIST_FAILURE:
        this.setQueryListResult(action.result);
        break;
      case standardAttributeConstants.GET_StandardAttribute_SUCCESS:
        this.setstandardAttributeList(action.result);
        break;
      case standardAttributeConstants.GET_StandardAttribute_FAILURE:
        this.setstandardAttributeList(action.result);
        break;
      case standardAttributeConstants.DELETE_ATTRIBUTE_SUCCESS:
        this.setDeletestandardAttribute(action.result);
        break;
      case standardAttributeConstants.DELETE_ATTRIBUTE_FAILURE:
        this.setDeletestandardAttribute(action.result);
        break;
      case standardAttributeConstants.GET_ATTRIBUTE_TYPE_SUCCESS:
        this.setAttributeTypes(action.result);
        break;
      case standardAttributeConstants.GET_ATTRIBUTE_TYPE_FAILURE:
        this.setAttributeTypes(action.result);
        break;
      case standardAttributeConstants.GET_ATTRIBUTE_OPTIONS_SUCCESS:
        this.setAttributeOptions(action.result);
        break;
      case standardAttributeConstants.GET_ATTRIBUTE_OPTIONS_FAILURE:
        this.setAttributeOptions(action.result);
        break;
      case standardAttributeConstants.SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_SUCCESS:
        this.setSaveUpdateWerkOptionsRes(action.result);
        break;
      case standardAttributeConstants.SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_FAILURE:
        this.setSaveUpdateWerkOptionsRes(action.result);
        break;
      case standardAttributeConstants.GET_STANDARD_ATTRIBUTE_OPTIONS_SUCCESS:
        this.setStandardAttributeOptions(action.result);
        break;
      case standardAttributeConstants.GET_STANDARD_ATTRIBUTE_OPTIONS_FAILURE:
        this.setStandardAttributeOptions(action.result);
        break;
      case standardAttributeConstants.GET_QUERY_DATA_RESULT_SUCCESS:
        this.setQueryDataResult(action.result);
        break;
      case standardAttributeConstants.GET_QUERY_DATA_RESULT_FAILURE:
        this.setQueryDataResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const standardAttributeStores = new StandardAttributeStores();
dispatcher.register(
  standardAttributeStores.handleCallback.bind(standardAttributeStores)
);
export default standardAttributeStores;
